/** a test secret phrase from which a valid eth address, eth signature can be derived */
export const mnemonic =
  'test test test test test test test test test test test junk';
export const ethereumAddress = '0xf39Fd6e51aad88F6F4ce6aB8827279cffFb92266';
export const startknetWalletSeed =
  '0xa3021d585eb7199916cca8c7b59b6a886a4807138548476fbd5dca9c0c6c9e254d045a2025c98da1a74f555ff2644a16d0a7c4c9ae1ad467ffe77b03193802741b';
